export default {
  getUserLanguage: (state) => state.userLanguage,
  getLocale: (state) => (state.userLanguage === 'Spanish' ? 'es' : 'en')
}
